/**
 * Definição única das colunas fixas do Kanban de Vistorias.
 *
 * @version 1.0.0
 * RELEASE: 2026-09-26 v1.0.0 - Criação conforme o padrão de Propostas.
 */
export interface InspectionKanbanColumnDef {
  status: string;
  label: string;
  barClass: string;
  headerClass: string;
}

export const INSPECTION_KANBAN_COLUMNS: InspectionKanbanColumnDef[] = [
  { status: 'pending', label: 'Pendente', barClass: 'bg-muted-foreground/40', headerClass: 'bg-muted-foreground/10' },
  { status: 'in_progress', label: 'Em andamento', barClass: 'bg-primary', headerClass: 'bg-primary/10' },
  { status: 'awaiting_review', label: 'Aguardando revisão', barClass: 'bg-warning', headerClass: 'bg-warning/10' },
  { status: 'correction_requested', label: 'Correção solicitada', barClass: 'bg-warning', headerClass: 'bg-warning/15' },
  { status: 'approved', label: 'Aprovada', barClass: 'bg-success', headerClass: 'bg-success/10' },
  { status: 'rejected', label: 'Reprovada', barClass: 'bg-destructive', headerClass: 'bg-destructive/10' },
  { status: 'cancelled', label: 'Cancelada', barClass: 'bg-muted-foreground/40', headerClass: 'bg-muted-foreground/10' },
];

const INSPECTION_STATUSES = new Set(INSPECTION_KANBAN_COLUMNS.map((column) => column.status));

/** Resolve somente status que possuem coluna no Kanban. */
export function resolveInspectionStatus(status?: string | null): string | null {
  return status && INSPECTION_STATUSES.has(status) ? status : null;
}